// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

// 联系人
export async function contacts(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/contacts', { method: 'GET', params: { ...params, }, });
}
export async function addContacts(body: CRM.ContactsListItem) {
  return request<CRM.ContactsListItem>('/api/contacts', { method: 'POST', data: body, });
}
export async function removeContacts(body: string[]) {
  return request<any>('/api/contacts/remove', { method: 'POST', data: body, });
}
export async function updateContacts(id: string, body: CRM.ContactsListItem) {
  return request<CRM.ContactsListItem>(`/api/contacts/${id}`, { method: 'PATCH', data: body, });
}

/** 产品列表 */
export async function products(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; }) {
  return request<CRM.ProductList>('/api/product', { method: 'GET', params: { ...params, } });

}
/**
 * 通用table的查询
 * @param params 
 * @returns 
 */
export async function getTableRecord(key, params: any) {
  return request<Fetch.Response>(`/api/${key}`, { method: 'GET', params });
}

/**
 * 通用table的表单新建
 * @param body 
 * @returns 
 */
export async function addTableRecord(key, body: CRM.ProductListItem) {
  return request<Fetch.Response>(`/api/${key}`, { method: 'POST', data: body, });
}

/**
 * 通用table的表单更新
 * @param param0 
 * @returns 
 */
export async function updateTableRecord({ id, body, key, }) {
  return request<Fetch.Response>(`/api/${key}/${id}`, { method: 'PATCH', data: body, });
}

/**
 * 通用table的批量删除
 * @param param0 
 * @returns 
 */
export async function deleteTableRecord(key, body: string[]) {
  return request<Fetch.Response>(`/api/${key}/remove`, { method: 'Post', data: body, });
}


/** 合同列表 */
export async function contracts(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/contract', { method: 'GET', params: { ...params, }, });
}

/** 客户列表 */
export async function customers(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/customer', { method: 'GET', params: { ...params, }, });
}
export async function addCustomer(body: any) {
  return request<any>('/api/customer', { method: 'POST', data: body });
}
export async function updateCustomer(id: string, body: any) {
  return request<any>(`/api/customer/${id}`, { method: 'PATCH', data: body });
}
export async function removeCustomer(body: string[]) {
  return request<string[]>('/api/customer/remove', { method: 'POST', data: body, });
}

export async function leads(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.LeadList>('/api/lead', { method: 'GET', params: { ...params, }, });
}

export async function activities(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/activity', { method: 'GET', params: { ...params, }, });
}

/** 新建线索 POST /api/lead */
export async function addLead(body: any) {
  return request<Fetch.Response>('/api/lead', { method: 'POST', data: body, });
}

/** 批量删除线索 POST /api/lead */
export async function removeLead(body: string[]) {
  return request<string[]>('/api/lead/remove', { method: 'POST', data: body, });
}

/** 批量删除线索 POST /api/lead */
export async function add2team(tableKey: string, body: { [key: string]: any }) {
  return request<Fetch.Response>(`/api/${tableKey}/add2team`, { method: 'POST', data: body, });
}

export async function users(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/setting/user', { method: 'GET', params: { ...params, }, });
}

// 商机
export async function opportunities(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/opportunity', { method: 'GET', params: { ...params, }, });
}
export async function addOpportunity(body: any) {
  return request<any>('/api/opportunity', { method: 'POST', data: body });
}
export async function removeOpportunity(body: any) {
  return request<any>('/api/opportunity/remove', { method: 'POST', data: body });
}
export async function updateOpportunity(id: string, body: any) {
  return request<any>(`/api/opportunity/${id}`, { method: 'PATCH', data: body });
}

// 数据字典
export async function dicts(params: { key?: string, current?: number; pageSize?: number; sorter?: any; filter?: any; },) {
  return request<CRM.ContactsList>('/api/dict', { method: 'GET', params: { ...params, }, });
}

// 详情
export async function getDetail(tableKey, params: { id?: number | string; },) {
  return request<Fetch.Response>(`/api/${tableKey}/${params.id}`, { method: 'GET', });
}


// 修改详情
export async function updateDetail(tableKey, params: { id: any }, data: any) {
  return request<Fetch.Response>(`/api/${tableKey}/${params.id}`, { method: 'PATCH', data, })
}

// 添加线索跟进记录
export async function addLeadFlowUp(data: any) {
  return request<Fetch.Response>(`/api/activity`, { method: 'POST', data, })
}


// 线索跟进记录
export async function getLeadFlowUp(params: { fromId: any }) {
  return request<Fetch.Response>(`/api/activity`, { method: 'GET', params, })
}

// 转移给其他人
export async function transfer2Other(tableKey: string, data: { key: any[], ownerId: any }) {
  return request<Fetch.Response>(`/api/${tableKey}/transfer`, { method: 'POST', data, })
}
// 线索转移到公海
export async function transfer2Common(tableKey: string, data: { key: any[], }) {
  return request<Fetch.Response>(`/api/${tableKey}/release`, { method: 'POST', data, })
}

// 搜索
export async function search(keyword: string) {
  return request<any>(`/api/search`, { method: 'GET', params: { keyword: keyword } })
}

export async function transfer(entity: string, data: { key: any[], ownerId: any }) {
  return request<Fetch.Response>(`/api/${entity}/transfer`, { method: 'POST', data, })
}

//线索转客户
export async function lead2customer(data) {
  return request<Fetch.Response>(`/api/lead/lead2customer`, { method: 'POST', data, })
}

// 发起审批
export async function apply(data: any) {
  return request<Fetch.Response>(`/api/flow/apply`, { method: 'POST', data, })
}

// oss签名
export async function ossSignature(data: any) {
  return request<Fetch.Response>(`/api/oss-signature`, { method: 'GET', })
}

export async function setChatdataKey() {
  return request<Fetch.Response>(`/api/rsa/generate`, { method: 'GET', })
}

export async function queryWelcomeMessage(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; }) {
  return request<Fetch.Response>(`/api/welcome-message`, { method: 'GET', params: { ...params } })
}
export async function createWelcomeMessage(data: any) {
  return request<Fetch.Response>(`/api/welcome-message`, { method: 'POST', data, })
}
export async function delWelcomeMessage(id: string) {
  return request<any>(`/api/welcome-message/${id}`, { method: 'DELETE' });
}
export async function getWelcomeMessage(id: string) {
  return request<Fetch.Response>(`/api/welcome-message/${id}`, { method: 'GET', });
}
export async function updateWelcomeMessage(id: string, data: any) {
  return request<any>(`/api/welcome-message/${id}`, { method: 'PATCH', data });
}

// agent
export async function getAnnotations(params: { current?: number; pageSize?: number; sorter?: any; filter?: any; }) {
  return request<any>(`/api/apps/annotations`, { method: 'GET', params: params })
}

export async function delAnnotation(annotation_id: string) {
  return request<any>(`/api/apps/annotations/${annotation_id}`, { method: 'DELETE' })
}
